<div class="p-2">
  <mat-form-field appearance="outline" class="col-md-3 mx-4">
    <mat-label>Select Centre</mat-label>
    <mat-select  [(ngModel)]="selectedCentre" (selectionChange)="search()">
      <mat-option *ngFor=" let c of (centres$|async) "
                  [value]="c.centreCode">{{c.centreName}} </mat-option>
      <!--      <mat-option  value="All">All Centres</mat-option>-->
    </mat-select>
  </mat-form-field>


  <mat-form-field appearance="outline" class="col-md-3 mx-4">
    <mat-label>Select Child</mat-label>
    <mat-select  [(ngModel)]="selectedChildCode" (selectionChange)="searchChild($event)">
      <mat-option *ngFor=" let c of (childBycentre|async)  "
                  [value]="c">{{c.firstName}} {{c.lastName}} </mat-option>
      <!--      <mat-option  value="All">All Centres</mat-option>-->
    </mat-select>
  </mat-form-field>
<!--<prettyjson [obj]="selectedChildCode"></prettyjson>-->

</div>
<div class="d-flex flex-column text-dark mx-4 ">
  <mat-checkbox class="example-margin" [(ngModel)]="showIndividual">Show Individual Sessions</mat-checkbox>
  <mat-checkbox class="example-margin" [(ngModel)]="showGroup"> Show Group Sessions</mat-checkbox>
  <div class=" text-end p-4">
    &nbsp;&nbsp;<button mat-mini-fab color="accent"  matTooltip="Search" (click)="SearchButton()">
    <mat-icon>search</mat-icon>
  </button>&nbsp;&nbsp;&nbsp;&nbsp;
    &nbsp;&nbsp;&nbsp;&nbsp;   <button mat-mini-fab color="accent"  (click)="clearAll()" matTooltip="Clear">
    <mat-icon>clear</mat-icon>

  </button>
  </div>


  <mat-form-field appearance="outline" class="col-md-4">
    <mat-label>Session Type</mat-label>
    <mat-select [(ngModel)]="sessionType" (selectionChange)="individualFilter($event)">
      <mat-option value="All">All</mat-option>
      <mat-option value="Rapport Building">Rapport Building</mat-option>
      <mat-option value="Baseline Assessment">Baseline Assessment</mat-option>
      <mat-option value="Regular Study">Regular Study</mat-option>
      <mat-option value="Intermediate Assessment">Intermediate Assessment</mat-option>
      <mat-option value="Discharge Assessment">Discharge Assessment</mat-option>
    </mat-select>
  </mat-form-field>
<section *ngIf="showIndividual" class="table-container">
  <h1>Individual Report</h1>
  <table mat-table [dataSource]="dataSourceIndividual" class="mat-elevation-z8" matSort>

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let element"> {{element.position}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="childName" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name </th>
      <td mat-cell *matCellDef="let element" [matTooltip]="element.id">{{element.childName}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre </th>
      <td mat-cell *matCellDef="let element" [matTooltip]="element.centreCode">{{element.centreName}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="sessionDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Date</th>
      <td mat-cell *matCellDef="let element"> {{(element.sessionDate).toDate() | date : 'dd/MM/yyyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="startTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Timing</th>
      <td mat-cell *matCellDef="let element"><span *ngIf="element.startTime!=null && element.startTime!='' ">  {{getTime(element?.startTime)}} </span> </td>
    </ng-container>
    <ng-container matColumnDef="sessionType" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type of Session</th>
      <td mat-cell *matCellDef="let element">{{element.sessionType}}  </td>
    </ng-container>
    <ng-container matColumnDef="subject">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Subject</th>
      <td mat-cell *matCellDef="let element"> {{element.subject}} </td>
    </ng-container>
    <ng-container matColumnDef="topic_covered">
      <th mat-header-cell *matHeaderCellDef>Topic Covered</th>
      <td mat-cell *matCellDef="let element"> {{element.topicsCovered}} </td>
    </ng-container>
    <!--            <ng-container matColumnDef="session">-->
    <!--                <th mat-header-cell *matHeaderCellDef>Session</th>-->
    <!--                <td mat-cell *matCellDef="let element">  </td>-->
    <!--            </ng-container>-->
    <ng-container matColumnDef="remark">
      <th mat-header-cell *matHeaderCellDef>Remark</th>
      <td mat-cell *matCellDef="let element"> {{element.remark}} </td>
    </ng-container>
    <ng-container matColumnDef="submittedBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Teacher</th>
      <td mat-cell *matCellDef="let element">{{element.submittedBy}}  </td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header > Created At </th>
      <td mat-cell *matCellDef="let element"> <span *ngIf='element.createdAt' >{{getDateandTime(element.createdAt)}}</span> </td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="accent" (click)="viewDialog(element)" matTooltip="View">

          <mat-icon>remove_red_eye</mat-icon>
        </button>
      </td>
    </ng-container>




    <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
  <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" aria-label="Select page of users"></mat-paginator>
</section>


  <mat-form-field appearance="outline" class="col-md-4">
    <mat-label>Session Type</mat-label>
    <mat-select [(ngModel)]="sessionType2" (selectionChange)=" groupFilter($event)">
      <mat-option value="All">All</mat-option>
      <mat-option value="Regular Study "> Regular Study</mat-option>
      <mat-option value="Activity Session">Activity Session</mat-option>
    </mat-select>
  </mat-form-field>
<section *ngIf="showGroup" class="table-container">
  <h1>Group Report</h1>

  <table mat-table [dataSource]="dataSourceGroup" class="mat-elevation-z8" matSort>

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef > No. </th>
      <td mat-cell *matCellDef="let element"> {{element.position}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name </th>
      <td mat-cell *matCellDef="let element">{{getChildrenString(element.children)}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="centre">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre </th>
      <td mat-cell *matCellDef="let element">{{getCentresString(element.centres)}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Date</th>
      <td mat-cell *matCellDef="let element"> {{(element.sessionDate).toDate() | date : 'dd/MM/yyyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="timing">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Timing</th>
      <td mat-cell *matCellDef="let element">{{getTime(element.startTime)}}  </td>
    </ng-container>
    <ng-container matColumnDef="type_session">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type of Session</th>
      <td mat-cell *matCellDef="let element">{{element.sessionType}}  </td>
    </ng-container>
    <ng-container matColumnDef="subject">
      <th mat-header-cell *matHeaderCellDef >Subject</th>
      <td mat-cell *matCellDef="let element"> {{element.subject}} </td>
    </ng-container>
    <ng-container matColumnDef="topic_covered">
      <th mat-header-cell *matHeaderCellDef >Topic Covered</th>
      <td mat-cell *matCellDef="let element"> {{element.topicsCovered}} </td>
    </ng-container>
    <ng-container matColumnDef="session">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Session</th>
      <td mat-cell *matCellDef="let element">  </td>
    </ng-container>
    <ng-container matColumnDef="remark">
      <th mat-header-cell *matHeaderCellDef >Remark</th>
      <td mat-cell *matCellDef="let element"> {{element.remark}} </td>
    </ng-container>
    <ng-container matColumnDef="teacher">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Teacher</th>
      <td mat-cell *matCellDef="let element">{{element.submittedBy}}  </td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Created At </th>
      <td mat-cell *matCellDef="let element"> <span *ngIf='element.createdAt' >{{getDateandTime(element?.createdAt)}}</span> </td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="primary" (click)="viewDialog2(element)" matTooltip="View"><mat-icon>remove_red_eye</mat-icon></button>


      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns2 sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
  </table>
</section>
